import { j as e } from "../../../jsx-runtime-B3iL8JI7.js";
import * as l from "@radix-ui/react-checkbox";
import { checkboxStyles as u } from "./Checkbox.styles.js";
import { CheckboxIcon as S } from "./CheckboxIcon.js";
import s from "../../../tailwindConfig/bclTwMerge.js";
const I = ({
  variant: c = "primary",
  id: i,
  label: t,
  checked: a,
  onCheckedChange: n,
  disabled: r = !1,
  className: m = "",
  "aria-label": x,
  tabIndex: b = 0,
  // Setting default value to solve Safari and Firefox keyboard navigation issues
  ...f
}) => {
  const {
    base: d,
    indicator: h,
    label: p,
    variant: j
  } = u, o = a === "indeterminate", y = typeof t == "string" ? t : "checkbox";
  return /* @__PURE__ */ e.jsxs("div", { className: s("flex items-center", m), children: [
    /* @__PURE__ */ e.jsx(
      l.Root,
      {
        "aria-checked": o ? "mixed" : a,
        "aria-label": x ?? y,
        className: s(d, j[c]),
        checked: o ? !0 : a,
        onCheckedChange: n,
        id: i,
        disabled: r,
        tabIndex: b,
        ...f,
        children: /* @__PURE__ */ e.jsx(l.Indicator, { className: `${h}`, children: /* @__PURE__ */ e.jsx(S, { checked: a, disabled: r }) })
      }
    ),
    /* @__PURE__ */ e.jsx(
      "label",
      {
        htmlFor: i,
        className: s(p, r && "text-disabled"),
        children: t
      }
    )
  ] });
};
export {
  I as default
};
